<script lang="ts">
import { Intention } from '~/models/Intention'

export default {
    name: 'IntentionEntityPanelStatus',
    props: {
        data: { type: Object, required: true },
        entity: { type: Intention, required: true },
        translationName: { type: String, required: true },
    },
    emits: ['updateStatus', 'saveStatus'],
    methods: {
        updateStatus(status: string) {
            // organization_id fix PIL-329, needed for frontend validation
            // commune_insee fix PIL-394, needed for frontend validation
            this.$emit('saveStatus', {
                [`status`]: status,
                organization_id: this.data.organization.id,
                commune_insee: this.data.commune.insee,
            })
        },
    },

}
</script>

<template>
    <div class="mb-3">
        <label class="v-label">
            {{ $translate(`${translationName}.status`) }}
        </label>
        <div class="mt-1">
            <v-chip
                :variant="$config.public.chips_variant || 'tonal'"
                :color="$getColor(`${translationName}.status.${data.status}`)"
            >
                {{ $translate(`${translationName}.status.${data.status}`) }}
            </v-chip>
            <template v-if="entity?.meta?.editable && $permissionCheck('voirie_intention_update')">
                <v-btn
                    v-if="data.status !== '_2_active'" prepend-icon="mdi-dots-circle" size="small" variant="text"
                    color="secondary" class="mx-1 ml-2" @click.prevent="updateStatus('_2_active')"
                >
                    En cours
                </v-btn>

                <v-btn
                    v-if="data.status !== '_3_done'" prepend-icon="mdi-check-circle" size="small" variant="text"
                    color="secondary" class="mx-1" @click.prevent="updateStatus('_3_done')"
                >
                    Réalisé
                </v-btn>

                <v-btn
                    v-if="data.status !== '_4_cancelled'" prepend-icon="mdi-close-circle" size="small" variant="text"
                    color="secondary" class="mx-1" @click.prevent="updateStatus('_4_cancelled')"
                >
                    Abandonné
                </v-btn>
            </template>
        </div>
    </div>

    <!-- case _1_new; //        A qualifier
    case _2_active; //     En cours
    case _3_done; //       Réalisé
    case _4_cancelled; //  Abandonné -->
</template>
